/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import env from "../context/Env"

export async function getManualUrlIfAvailableAsync(
    chapter: string,
    id: string
): Promise<string | null> {
    const linkString = `${env("USER_MANUAL_URL")}/${chapter}`
    const request = new XMLHttpRequest()

    return new Promise<string | null>((resolve) => {
        request.open("GET", linkString, true)
        request.onload = () => {
            if (request.responseText.includes(`id="${id}"`)) {
                resolve(`${linkString}#${id}`)
            } else {
                resolve(null)
            }
        }
        request.onerror = () => {
            resolve(null)
        }
        request.send()
    })
}

export function getManualUrlIfAvailable(
    chapter: string,
    id: string
): string | null {
    const linkString = `${env("USER_MANUAL_URL")}/${chapter}`
    const request = new XMLHttpRequest()
    request.open("GET", linkString, false)
    request.send()
    if (request.responseText.includes(`id="${id}"`)) {
        return `${linkString}#${id}`
    }
    return null
}
